import { SxProps, Tooltip, Typography } from '@mui/material';
import { createRef } from 'react';

import useTooltip from 'core/hooks/useTooltip';

export const LongTextTooltip = ({
	title,
	sx,
	variant,
}: {
	title: string;
	sx?: SxProps;
	variant?:
		| 'button'
		| 'caption'
		| 'h1'
		| 'h2'
		| 'h3'
		| 'h4'
		| 'h5'
		| 'h6'
		| 'inherit'
		| 'subtitle1'
		| 'subtitle2'
		| 'body1'
		| 'body2'
		| 'overline';
}) => {
	const itemTitleRef = createRef<HTMLDivElement>();
	const isTooltipVisible = useTooltip(itemTitleRef);

	return (
		<Tooltip
			componentsProps={{
				tooltip: {
					sx: {
						backgroundColor: '#f5f5f9',
						color: 'rgba(0, 0, 0, 0.87)',
						fontSize: '12px',
						maxWidth: 250,
						border: '1px solid #dadde9',
						'& .MuiTooltip-popper': { margin: 0 },
					},
				},
			}}
			PopperProps={{
				modifiers: [
					{
						name: 'offset',
						options: {
							offset: [0, -15],
						},
					},
				],
			}}
			title={isTooltipVisible ? title : null}
			placement="top"
		>
			<Typography
				ref={itemTitleRef}
				variant={variant}
				sx={{
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					overflow: 'hidden',
					...sx,
				}}
			>
				{title}
			</Typography>
		</Tooltip>
	);
};
